<template>
    <v-modal title="Reissue" size="large" @close="$emit('close')">
        <div slot="contents">
            <div class="modal-content">
                <div class="grid-item grid-item-full">
                    <h3 class="stack-m">Due Date</h3>
                    <div class="grid-fitted">
                        <div class="grid-item">
                            <v-date-input
                                type="datetime"
                                v-model="dueTime"
                                :available-dates='availableDueDates'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template slot="actions">
            <r-button
                type="primary"
                @click="issue">
                Reissue
            </r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {
        vDateInput,
    } from '@/components/form';

    export default {
        components: {
            vModal,
            vDateInput,
        },
        computed: {
            availableDueDates() {
                return {
                    start: this.$tz().now(),
                    end: null,
                };
            },
        },
        data() {
            return {
                dueTime: this.$tz().now(),
            };
        },
        methods: {
            issue() {
                this.$emit('reissue-invoice', {dueTime: this.dueTime.format()});
                this.$emit('close');
            },
        },
    };
</script>
